"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCallActivities = void 0;
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const ExtensionPropertyParser_1 = require("./ExtensionPropertyParser");
function parseCallActivities(processData) {
    const callActivitiesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.CallActivity);
    const noCallActivitiesFound = !((callActivitiesRaw === null || callActivitiesRaw === void 0 ? void 0 : callActivitiesRaw.length) > 0);
    if (noCallActivitiesFound) {
        return [];
    }
    const callActivities = [];
    for (const callActivityRaw of callActivitiesRaw) {
        const flowNodeId = callActivityRaw.id;
        try {
            callActivities.push(parseCallActivity(callActivityRaw));
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    }
    return callActivities;
}
exports.parseCallActivities = parseCallActivities;
function parseCallActivity(callActivityRaw) {
    let callActivity = (0, ActivityFactory_1.createActivityInstance)(callActivityRaw, index_1.Model.Activities.CallActivity);
    if (callActivityRaw.calledElement) {
        setStartEventId(callActivity);
        setPayload(callActivity);
        callActivity.calledReference = callActivityRaw.calledElement;
        // NOTE: There is also a CMMN type, which is not supported yet.
        callActivity.type = index_1.Model.Activities.CallActivityType.BPMN;
        callActivity.bindingType = callActivityRaw[index_1.BpmnTags.CamundaProperty.CalledElementBinding];
        if (callActivity.bindingType === index_1.Model.Activities.CallActivityBindingType.version) {
            callActivity.calledElementVersion = callActivityRaw[index_1.BpmnTags.CamundaProperty.CalledElementVersion];
        }
        callActivity.calledElementTenantId = callActivityRaw[index_1.BpmnTags.CamundaProperty.CalledElementTenantId];
        callActivity = determineCallActivityMappingType(callActivity, callActivityRaw);
    }
    return callActivity;
}
function setStartEventId(callActivity) {
    var _a;
    callActivity.startEventId = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('startEventId', callActivity.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
function setPayload(callActivity) {
    var _a;
    callActivity.payload = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('payload', callActivity.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
function determineCallActivityMappingType(callActivity, data) {
    if (data[index_1.BpmnTags.CamundaProperty.VariableMappingClass]) {
        callActivity.delegateVariableMapping = index_1.Model.Activities.CallActivityDelegateVariableMapping.variableMappingClass;
        callActivity.variableMappingValue = data[index_1.BpmnTags.CamundaProperty.VariableMappingClass];
    }
    else if (data[index_1.BpmnTags.CamundaProperty.VariableMappingDelegateExpression]) {
        callActivity.delegateVariableMapping = index_1.Model.Activities.CallActivityDelegateVariableMapping.variableMappingDelegateExpression;
        callActivity.variableMappingValue = data[index_1.BpmnTags.CamundaProperty.VariableMappingDelegateExpression];
    }
    else {
        callActivity.delegateVariableMapping = index_1.Model.Activities.CallActivityDelegateVariableMapping.Unspecified;
    }
    return callActivity;
}
//# sourceMappingURL=CallActivityParser.js.map